import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTheme } from 'styled-components'
import moment from 'moment'

import IconPng from 'atoms/IconPng'
import { FormSelect } from 'atoms/Inputs'
import { Label, TxtLink } from 'atoms/Texts'
import { GET_CONTRACTORS, SEARCH_USERS } from 'fixtures/api'
import {
  ContractorReports,
  ValidationStatus,
  MineMarketStatus,
  ValidationDataTypes,
} from 'fixtures/enums'
import { toggleIsLoading } from 'Redux/actions/ViewStateActions'
import {
  deleteBulkData,
  deleteData,
  getAllList,
  postNewData,
} from 'services/cmsService'
import RainfallValidation from './RainfallValidation'
import {
  Button,
  EmptyWrapper,
  FilterCol,
  FilterRow,
  RoundedWrapper,
  StyledDatePicker,
  Typeahead,
  PaddedWrapper,
} from './styles'
import RitOBValidation from './RitOBValidation'
import { permissionCheck } from 'helpers/permissionCheckHelper'
import _ from 'lodash'
import {
  TxtSuccessDeleteBulk,
  TxtFailedDeleteBulk,
  TxtConfirmDeleteReport,
  TxtFailedDeleteDept,
  TxtFailedValidated,
  TxtSuccessDeleteReport,
  TxtSuccessValidated,
} from 'fixtures/texts'
import {
  contractorReportOBApprove,
  contractorReportOBCreate,
  contractorReportOBDelete,
  contractorReportOutpitRSApprove,
  contractorReportOutpitRSCreate,
  contractorReportOutpitRSDelete,
  contractorReportRSApprove,
  contractorReportRSCreate,
  contractorReportRSDelete,
  outpitWorkApprove,
  outpitWorkCreate,
  outpitWorkDelete,
  pumpingProgressApprove,
  pumpingProgressCreate,
  pumpingProgressDelete,
} from 'fixtures/permissions'
import PumpingValidation from './PumpingValidation'
import OutpitRainfallValidation from './OutpitRainfallValidation'
import OutpitWorkValidation from './OutpitWorkValidation'

const ic_eye = require('App/assets/images/ic_eye.png')
const ic_folder = require('App/assets/images/ic_folder.png')
const ic_arrow_left = require('App/assets/images/ic_arrow_left.png')

const SERVER_URL = process.env.BACKEND_URL
const { REPORT_URL } = process.env
const permissions = {
  ritOBValidations: {
    allowApprove: contractorReportOBApprove,
    allowDelete: contractorReportOBDelete,
    allowAdd: contractorReportOBCreate,
  },
  rainfallValidations: {
    allowApprove: contractorReportRSApprove,
    allowDelete: contractorReportRSDelete,
    allowAdd: contractorReportRSCreate,
  },
  outpitRainfallValidations: {
    allowApprove: contractorReportOutpitRSApprove,
    allowDelete: contractorReportOutpitRSDelete,
    allowAdd: contractorReportOutpitRSCreate,
  },
  outpitWorkValidations: {
    allowApprove: outpitWorkApprove,
    allowDelete: outpitWorkDelete,
    allowAdd: outpitWorkCreate,
  },
  pumpingProgressValidations: {
    allowApprove: pumpingProgressApprove,
    allowDelete: pumpingProgressDelete,
    allowAdd: pumpingProgressCreate,
  },
}
class DataValidation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navList: ['Data Validation', 'Data Validation List'],
      users: [],
      contractors: [],
      filters: {
        companyId: '-',
        typeId: '-',
        createdAt: null,
        transactionDate: new Date(),
        isValidated: '-',
        mmStatus: '-',
        validatedBy: '',
        contractorId: '',
      },
      currFilters: {
        typeId: '-',
      },
      checked: [],
      allChecked: false,
      data: null,
      isEdited: false,
      isAnyUnvalidated: false,
    }
  }

  inputConfig = {
    border: this.props.theme.mocaGrey,
    rad: '6px',
    width: 'auto',
    yxPadding: '9px 12px',
    height: '34px',
    arrowSize: '16px',
    arrowPos: 'calc(100% - 12px)',
  }

  componentDidMount() {
    this.getSavedData()
  }

  setActiveType = (ref) => {
    this.activeType = ref
  }

  onFilterChange = (field, val) => {
    const { filters } = this.state
    filters[field] = val
    this.setState({ filters })

    if (field === 'companyId') {
      this.fetchContractors()
    }
  }

  onSearchUser = _.debounce(async (e) => {
    if (!e.length) this.setState({ users: [] })
    if (e.length >= 4) {
      const users = await getAllList(`${SEARCH_USERS}?fullname=${e}`)
      this.setState({ users })
    }
  }, 500)

  buildParams = () => {
    // TODO: add mmStatus filter after be fix it
    const {
      typeId,
      createdAt,
      transactionDate,
      validatedBy,
      mmStatus,
      ...otherFilters
    } = this.state.filters
    const params = Object.keys(otherFilters)
      .filter((k) => otherFilters[k] !== '-')
      .map((k) => `${k}=${otherFilters[k]}`)
      .concat([
        ...(transactionDate
          ? [`transactionDate=${moment(transactionDate).format('YYYY-MM-DD')}`]
          : []),
        ...(createdAt
          ? [`createdAt=${moment(createdAt).format('YYYY-MM-DD')}`]
          : []),
        ...(validatedBy ? [`validatedBy=${validatedBy.username}`] : []),
      ])
      .join('&')
    return params
  }

  onView = async () => {
    const { typeId } = this.state.filters
    this.setState({
      currFilters: '-',
      checked: [],
    })
    const params = this.buildParams()
    const data = await getAllList(`${SERVER_URL}/${typeId}?${params}`)
    this.setState({
      data,
      currFilters: _.cloneDeep(this.state.filters),
      isEdited: false,
    })
  }

  onRefreshData = async () => {
    const { typeId } = this.state.currFilters
    const params = this.buildParams()
    const data = await getAllList(`${SERVER_URL}/${typeId}?${params}`)
    this.setState({
      data,
      checked: [],
      allChecked: false,
      isAnyUnvalidated: false,
    })
  }

  onAdd = () => this.activeType.addNew()

  onEdited = () => this.setState({ isEdited: true })

  onCancel = () => this.setState({ isEdited: false })

  onSave = () => this.setState({ isEdited: false })

  onChecked = (id) => {
    this.setState(
      {
        checked: _.xor(this.state.checked, [id]),
      },
      () => {
        const isContractor =
          this.props.userDetail.userRole === 'CONTRACTOR' ||
          String(this.props.userDetail.department.name)
            .toLowerCase()
            .includes('contractor')

        // if all data is checked, check all checkbox
        this.setState(({ checked, data }) => ({
          allChecked:
            checked.length ===
            data.filter((d) => {
              if (isContractor) {
                return !d.validatedAt
              }
              return true
            }).length,
          isAnyUnvalidated: this.getUnvalidatedData(),
        }))
      }
    )
  }
  onAllChecked = (ids) => {
    const isContractor =
      this.props.userDetail.userRole === 'CONTRACTOR' ||
      String(this.props.userDetail.department.name)
        .toLowerCase()
        .includes('contractor')
    const anyUnvalidatedData =
      this.state.data.filter((d) => !d.validatedAt).length > 0
    if (isContractor && !anyUnvalidatedData) return
    this.setState(
      {
        allChecked: !this.state.allChecked,
        checked: !this.state.allChecked ? ids : [],
      },
      () => {
        this.setState({
          isAnyUnvalidated: this.getUnvalidatedData(),
        })
      }
    )
  }
  onValidate = async () => {
    try {
      const { data, checked } = this.state
      const validateDataIds = data.reduce((acc, curr) => {
        if (checked.includes(curr.id) && !curr.validatedAt) acc.push(curr.id)
        return acc
      }, [])
      const url = `${SERVER_URL}/${this.state.currFilters.typeId}/validate`
      const res = await postNewData(url, [...validateDataIds])

      if (res.status === 201 || res.status === 204 || res.status === 200) {
        alert(TxtSuccessValidated)
        await this.onRefreshData()
      } else {
        throw res
      }
    } catch (error) {
      alert(TxtFailedValidated)
    }
  }

  onDelete = async (data) => {
    const isOk = window.confirm(TxtConfirmDeleteReport)
    if (isOk) {
      const url = `${SERVER_URL}/${this.state.currFilters.typeId}/${data.id}`
      try {
        const res = await deleteData(url)
        if (res.status !== 500) {
          alert(TxtSuccessDeleteReport)
          this.onRefreshData()
        } else {
          throw res
        }
      } catch (error) {
        alert(TxtFailedDeleteDept)
      }
    }
  }

  onDeleteBulk = async () => {
    try {
      const ids = _.cloneDeep(this.state.checked)
      const url = `${SERVER_URL}/${this.state.currFilters.typeId}`
      const res = await deleteBulkData(url, [...ids])

      if (res.status === 201 || res.status === 204 || res.status === 200) {
        alert(TxtSuccessDeleteBulk)
        await this.onRefreshData()
      } else {
        throw res
      }
    } catch (error) {
      alert(TxtFailedDeleteBulk)
    }
  }

  onExport = () => {
    const { typeId } = this.state.filters
    const selectedType = ContractorReports.find((r) => r.id === typeId)
    const params = this.buildParams()
    window.open(`${REPORT_URL}${selectedType.reportCode}&${params}`)
  }

  checkPermissions = (permission) => {
    const { userDetail } = this.props
    return permissionCheck(userDetail.permissions, permission)
  }

  getSavedData() {
    if (window.sessionStorage.getItem('dataValidationRow') !== null) {
      let data = JSON.parse(window.sessionStorage.getItem('dataValidationRow'))
      data.date = new Date(data.date)
      const dataType = ValidationDataTypes.find(
        (d) => d.value === data.dataType
      )
      data.dataType = dataType ? dataType.key : ''
      this.onFilterChange('transactionDate', data.date)
      this.onFilterChange('typeId', data.dataType)
    }

    if (window.sessionStorage.getItem('dataValidationFilters') !== null) {
      let filterData = JSON.parse(
        window.sessionStorage.getItem('dataValidationFilters')
      )
      this.onFilterChange('companyId', filterData.companyId.value)
    }

    this.setState({ currFilters: _.cloneDeep(this.state.filters) }, () => {
      this.onRefreshData()
    })
  }

  getUnvalidatedData = () => {
    const { data, checked } = this.state
    const unvalidatedData = data.reduce((acc, curr) => {
      if (checked.includes(`${curr.id}`) && !curr.validatedAt) acc.push(curr)
      return acc
    }, [])
    return unvalidatedData.length > 0
  }

  fetchContractors = async () => {
    const { filters } = this.state;

    const dataApi = await getAllList(`${GET_CONTRACTORS}?companyId=${filters.companyId}`)
    this.setState({
      contractors: dataApi,
      filters: {
        ...filters,
        contractorId: '-'
      }
    })
  }

  renderPicker = (
    label,
    options = [],
    key,
    valField = 'id',
    dispField = 'name',
    isBoolean = false
  ) => {
    const { filters } = this.state

    return (
      <FilterCol>
        <Label
          lineheight={'14px'}
          size={'12px'}
        >
          {label}
        </Label>
        <FormSelect
          placeholder={`Select ${label}`}
          onChangeVal={(e) =>
            this.onFilterChange(
              key,
              isBoolean ? JSON.parse(e.target.value) : e.target.value
            )
          }
          options={options}
          value={filters[key]}
          valField={valField}
          dispField={dispField}
          {...this.inputConfig}
        />
      </FilterCol>
    )
  }

  render() {
    const {
      theme,
      history: { goBack },
      companies,
    } = this.props
    const {
      users,
      filters,
      data,
      isEdited,
      currFilters,
      checked,
      allChecked,
      isAnyUnvalidated,
      contractors
    } = this.state
    const permission = permissions[filters.typeId] || {}
    return (
      <div>
        <TxtLink
          weight={'bold'}
          color={theme.mocaPurple}
          size={'14'}
          showPointer
          onClick={() => {
            window.sessionStorage.removeItem('dataValidationRow')
            goBack()
          }}
        >
          <IconPng
            srcIcon={ic_arrow_left}
            showPointer={true}
            mr={'8px'}
            mb={'3px'}
            size={'auto'}
            h={'13'}
          />
          Back to History Data Validation
        </TxtLink>
        <RoundedWrapper>
          <FilterRow pb={8}>
            {this.renderPicker('Company', companies, 'companyId')}
            {this.renderPicker(
              'Contractor Report',
              ContractorReports,
              'typeId'
            )}
            <FilterCol>
              <Label
                lineheight={'14px'}
                size={'12px'}
              >
                Date
              </Label>
              <StyledDatePicker
                onChange={(createdAt) =>
                  this.onFilterChange('createdAt', createdAt)
                }
                value={filters.createdAt}
              />
            </FilterCol>
            <FilterCol>
              <Label
                lineheight={'14px'}
                size={'12px'}
              >
                Transaction Date
              </Label>
              <StyledDatePicker
                onChange={(date) =>
                  this.onFilterChange('transactionDate', date)
                }
                value={filters.transactionDate}
              />
            </FilterCol>
          </FilterRow>
          <FilterRow pb={32}>
            {this.renderPicker(
              'Status Validate',
              ValidationStatus,
              'isValidated',
              'id',
              'name',
              true
            )}
            {this.renderPicker(
              'Status Mine Market',
              MineMarketStatus,
              'mmStatus',
              'id',
              'name',
              true
            )}
            <FilterCol>
              <Label
                lineheight={'14px'}
                size={'12px'}
              >
                User
              </Label>
              <Typeahead
                placeholder={'Select User'}
                options={users}
                dispField={'displayName'}
                control={filters.validatedBy ? [filters.validatedBy] : []}
                onChangeVal={(e) => this.onFilterChange('validatedBy', e)}
                onInputChange={(e) => this.onSearchUser(e)}
              />
            </FilterCol>
            {this.renderPicker(
              'Contractor',
              contractors,
              'contractorId',
              'id',
              'name'
            )}
          </FilterRow>
          <PaddedWrapper>
            <Button
              btnTxt={
                <IconPng
                  srcIcon={ic_eye}
                  ml={'0'}
                  mb={'3px'}
                  size={'auto'}
                  h={'13'}
                  showPointer={true}
                />
              }
              rad={'6px'}
              onClick={this.onView.bind(this)}
              width={'34px'}
              height={'34px'}
              mr={'16px'}
            />
            {isEdited && (
              <>
                <Button
                  btnTxt={'Cancel'}
                  rad={'6px'}
                  onClick={this.onCancel.bind(this)}
                  height={'34px'}
                  mr={'16px'}
                />
                <Button
                  btnTxt={'Save'}
                  rad={'6px'}
                  onClick={this.onSave.bind(this)}
                  height={'34px'}
                  mr={'16px'}
                />
              </>
            )}
            {this.checkPermissions(permission.allowApprove) && (
              <Button
                disabled={!data || data.length === 0 || !isAnyUnvalidated}
                btnTxt={'Validated'}
                rad={'6px'}
                onClick={this.onValidate.bind(this)}
                height={'34px'}
                mr={'16px'}
              />
            )}
            {this.checkPermissions(permission.allowDelete) && (
              <Button
                disabled={!data || data.length === 0 || !checked.length}
                btnTxt={'Delete'}
                rad={'6px'}
                onClick={this.onDeleteBulk.bind(this)}
                height={'34px'}
                mr={'16px'}
                bg={'red'}
              />
            )}
            <Button
              disabled={!data || data.length === 0}
              btnTxt={'Export'}
              rad={'6px'}
              onClick={this.onExport.bind(this)}
              height={'34px'}
              mr={'16px'}
            />
            {this.checkPermissions(permission.allowAdd) && (
              <Button
                disabled={!data}
                btnTxt={'Add'}
                rad={'6px'}
                onClick={this.onAdd.bind(this)}
                height={'34px'}
                mr={'16px'}
              />
            )}

            {!data && (
              <EmptyWrapper className="text-center">
                <div>
                  <IconPng
                    srcIcon={ic_folder}
                    size={'auto'}
                    h={'86'}
                    mb={'20px'}
                  />
                </div>
                <Label
                  weight={'600'}
                  lineheight={'14px'}
                  mb={'35px'}
                  size={'12px'}
                >
                  {`Select filters and click "Edit” button to start`}
                </Label>
              </EmptyWrapper>
            )}

            {!!data && currFilters.typeId === 'rainfallValidations' && (
              <RainfallValidation
                {...this.props}
                data={data}
                isCheckedAll={allChecked}
                onAllChecked={this.onAllChecked}
                onChecked={this.onChecked}
                onRefresh={this.onRefreshData}
                onRef={this.setActiveType}
              />
            )}
            {!!data && currFilters.typeId === 'ritOBValidations' && (
              <RitOBValidation
                {...this.props}
                data={data}
                onEdited={this.onEdited}
                onChecked={this.onChecked}
                isCheckedAll={allChecked}
                onAllChecked={this.onAllChecked}
                onDelete={this.onDelete}
                onRefresh={this.onRefreshData}
                onRef={this.setActiveType}
              />
            )}
            {!!data && currFilters.typeId === 'pumpingProgressValidations' && (
              <PumpingValidation
                {...this.props}
                data={data}
                onEdited={this.onEdited}
                onChecked={this.onChecked}
                isCheckedAll={allChecked}
                onAllChecked={this.onAllChecked}
                onDelete={this.onDelete}
                onRefresh={this.onRefreshData}
                onRef={this.setActiveType}
              />
            )}
            {!!data && currFilters.typeId === 'outpitWorkValidations' && (
              <OutpitWorkValidation
                {...this.props}
                data={data}
                onEdited={this.onEdited}
                onChecked={this.onChecked}
                isCheckedAll={allChecked}
                onAllChecked={this.onAllChecked}
                onDelete={this.onDelete}
                onRefresh={this.onRefreshData}
                onRef={this.setActiveType}
              />
            )}
            {!!data && currFilters.typeId === 'outpitRainfallValidations' && (
              <OutpitRainfallValidation
                {...this.props}
                data={data}
                onEdited={this.onEdited}
                onChecked={this.onChecked}
                isCheckedAll={allChecked}
                onAllChecked={this.onAllChecked}
                onDelete={this.onDelete}
                onRefresh={this.onRefreshData}
                onRef={this.setActiveType}
              />
            )}
          </PaddedWrapper>
        </RoundedWrapper>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const userDetail = state.userLogin ? state.userLogin.userDetail : null
  return {
    viewState: state.viewState,
    userDetail,
    companies: userDetail ? userDetail.allowedCompanies : [],
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleIsLoading,
    },
    dispatch
  )

export default withRouter(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(DataValidation))
)
